export class UpdateProtectedResource {
  constructor(
    public name: string,
    public safeMFAEnabled: boolean,
    public apiServer: string,
    public enableLoginCache: boolean,
    public serverTimeout: number,
    public allowMicrosoftAccountLogin: boolean,
    public settingsId: string
  ) {}
}
